<template>
  <path
    d="M9.29 6.71027C8.9 7.10027 8.9 7.73027 9.29 8.12027L13.17 12.0003L9.29 15.8803C8.9 16.2703 8.9 16.9003 9.29 17.2903C9.68 17.6803 10.31 17.6803 10.7 17.2903L15.29 12.7003C15.68 12.3103 15.68 11.6803 15.29 11.2903L10.7 6.70027C10.32 6.32027 9.68 6.32027 9.29 6.71027Z"
  />
</template>
